import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/UserDrawApi/';
export const putFavorite = (data)=>{
  return getInterface.post(`${prefixUrl}putFavorite`, data);
}
export const queryFavorites = (data)=>{
  return getInterface.post(`${prefixUrl}queryFavorites`, data);
}
export const delFavorite = (data)=>{
  return getInterface.post(`${prefixUrl}delFavorite/${data}`, {});
}
export const queryFavoriteDetail = (data)=>{
  return getInterface.post(`${prefixUrl}queryFavoriteDetail`, data);
}
export const saveGraphic = (data)=>{
  return getInterface.post(`${prefixUrl}saveGraphic`, data);
}
export const delGraphic = (data)=>{
  return getInterface.post(`${prefixUrl}delGraphic/${data}`, {});
}
export const queryAdminGraphicList = (data)=>{
  return getInterface.post(`${prefixUrl}queryAdminGraphicList`, data);
}
// 事件
export const getEventListByCoordinates = (data)=>{
  return getInterface.post(`${prefixUrl}getEventListByCoordinates`, data);
}
// 事件详情
export const getEventAllDetail = (data)=>{
  return getInterface.post(`${prefixUrl}getEventAllDetail`, data);
}
// 标注推送
export const configMarkPush = (data)=>{
  return getInterface.post(`${prefixUrl}configMarkPush`, data);
}
// 标注分组 - all
export const queryFavoritesByDetectivePhoto = (data)=>{
  return getInterface.post(`${prefixUrl}queryFavoritesByDetectivePhoto`, data);
}